import '@babel/polyfill';
import Vue from 'vue';
import './bootstrap.js';
import router from './routes';
import moment from 'moment';
import { tns } from 'tiny-slider/src/tiny-slider';
window.Vue = Vue;
window.moment = moment;
window.anime = require('animejs/lib/anime');
window.tns = tns;
require('@lottiefiles/lottie-player');
require('./slick/slick.js');
require('./side');
require('./selectric');

$(window).on('load', function() {
    if ($('#preloader').length > 0) {
        $('#preloader')
            .delay(300)
            .fadeOut('slow');
    }
});

window.$(document).ready(function() {
    // update placeholder
    function updatePlaceholder() {
        menuPlaceholderDefaultValue == menuPlaceholder.text()
            ? menuPlaceholder.text(menuPlaceholderText)
            : menuPlaceholder.text(menuPlaceholderDefaultValue);
        menuContainer.toggleClass('is-open');

        return false;
    }

    window.$('.content-bar__btn--filter-toggle').on('click', function() {
        $(this).toggleClass('is-active');
    });

    $('.content-bar__select').selectric({
        maxHeight: 300,
    });

    // Content menu behaviour
    if ($('.content-bar__menu').length) {
        var menuContainer = $('.content-bar__menu'),
            menuPlaceholder = menuContainer.find('.placeholder a'),
            menuPlaceholderText = menuPlaceholder.text(),
            menuPlaceholderDefaultValue = 'Select',
            siteBody = $('body');

        // detect click event
        menuContainer.on('click', function(event) {
            if (menuPlaceholder.is(':visible')) {
                // check if user has clicked the placeholder item (mobile view)
                if (
                    $(event.target).is(menuPlaceholder) ||
                    $(event.target).is(menuContainer)
                ) {
                    updatePlaceholder(event);
                }
            }
        });
        menuContainer.find('.placeholder a').click(function(e) {
            e.preventDefault();
        });

        // close menu clicking outside the menu itself
        siteBody.on('click', function(e) {
            var eTarget = $(e.target);

            if (
                !eTarget.is('.content-bar__menu, .content-bar__menu *') &&
                menuContainer.hasClass('is-open')
            ) {
                updatePlaceholder();
            }
        });
    }
});

var axios = require('axios');
var VueAxios = require('vue-axios');
Vue.use(VueAxios, axios);

const component = module => module.default || module;

Vue.component(
    'validation-message',
    component(require('./components/ui/ValidationMessage'))
);
Vue.component(
    'ValidationMessage',
    component(require('./components/ui/ValidationMessage'))
);
Vue.component(
    'TheSignUpNewsletter',
    component(require('./components/TheSignUpNewsletter/Index'))
);
Vue.component('TruncateHtml', component(require('./components/common/TruncateHtml')));

new Vue({
    el: '#app',

    data: {
        showMainLoadingBar: false,
    },

    router,
});
